export default function RequestHowItWorks() {
  const steps = [
    {
      number: '01',
      icon: 'ri-message-3-line',
      title: 'Tell Us What You Want',
      description: 'Fill out the form below with your ideal vehicle specs, budget, and timeline. The more details, the better we can hunt.'
    },
    {
      number: '02',
      icon: 'ri-search-line',
      title: 'We Hunt It Down',
      description: 'Our team scours auctions, trade-ins, and dealer networks across the Pacific Northwest to find vehicles that match your criteria.'
    },
    {
      number: '03',
      icon: 'ri-shield-check-line',
      title: 'We Inspect & Negotiate',
      description: 'Every vehicle gets a thorough inspection. Then we negotiate hard to get you the best possible price — no dealer markup.'
    },
    {
      number: '04',
      icon: 'ri-truck-line',
      title: 'We Deliver to You',
      description: 'Once approved, we handle all paperwork and deliver the vehicle to your door. You never have to step foot in a dealership.'
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            How It Works
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            From request to delivery, we handle everything. You just tell us what you want.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              {/* Connector Line (desktop only) */}
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-12 left-full w-full h-0.5 bg-gradient-to-r from-amber-400 to-transparent -translate-x-1/2 z-0"></div>
              )}
              
              <div className="relative z-10 text-center">
                {/* Number Badge */}
                <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gradient-to-br from-amber-400 to-amber-500 text-white font-bold text-xl mb-4 shadow-lg">
                  {step.number}
                </div>
                
                {/* Icon */}
                <div className="flex items-center justify-center w-12 h-12 mx-auto mb-4">
                  <i className={`${step.icon} text-4xl text-slate-700`}></i>
                </div>
                
                {/* Content */}
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {step.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}